import Tool, {
  type ToolArgsWithController,
  type ToolArgs,
} from '../../../tools/Tool';
import { LOCAL_ONLY_ANNOTATION_KEY } from '../utils';
import Annotations from '../Annotations';
import type { AnnotationKind } from '../../../types/aha-editor';
import { Range } from 'slate';
import commentPlusIcon from '../../../assets/icons/commentPlusIcon.svg';

class ToolCreateAnnotation extends Tool {
  static toolName = 'Generic Annotation';
  static annotationKind: AnnotationKind = 'comment';

  static action({ editor, controller, annotationProperties }: ToolArgs): void {
    const provider = controller.ahaEditor.getProvider('annotations');
    if (!provider) return;

    // Create a new temporary annotation.
    const key = LOCAL_ONLY_ANNOTATION_KEY;
    Annotations.addAnnotation(editor, {
      range: editor.selection,
      key,
      kind: this.annotationKind,
      annotationProperties,
    });

    const text = Annotations.getAnnotatedText(
      editor,
      // @ts-expect-error we just created the annotation above so metadata must exist.
      editor.metadata.annotations[key]
    );

    // Tell the application that a new annotation has been created.
    provider.onNewAnnotation(text, this.annotationKind);
  }

  // Can only create annotations if we have a selection
  static available({ editor, controller }: ToolArgsWithController) {
    return Boolean(
      controller.ahaEditor.hasProvider('annotations') &&
        editor.selection &&
        !Range.isCollapsed(editor.selection)
    );
  }
}

// Create a comment annotation.
class ToolCreateCommentAnnotation extends ToolCreateAnnotation {
  static toolName = 'Add comment';
  static iconSvg = commentPlusIcon;
  static annotationKind: AnnotationKind = 'comment';

  static action(toolArgs: ToolArgs): void {
    super.action({
      ...toolArgs,
      annotationProperties: { resolved: false, hidden: false },
    });
  }
}

// We want a different icon when using the toolbar above the selection.
class ToolCreateCommentAnnotationAbove extends ToolCreateCommentAnnotation {
  static iconClass = 'far fa-comment-medical';
}

export { ToolCreateAnnotation, ToolCreateCommentAnnotationAbove };
export default ToolCreateCommentAnnotation;
